import type { OnboardingToggle, ProfileDetail } from 'api-response';
import { isIdnTimesEmail } from './identity';

export const getOnboardingToggle = (userProfileDetail?: ProfileDetail, config?: OnboardingToggle) => {
  let toggle: 'on' | 'off' | undefined;

  if (userProfileDetail && config) {
    const activeToggle = config.config.find(({ isActive }) => isActive);

    if ((activeToggle?.toggle === 'on' || activeToggle?.toggle === 'off') && isIdnTimesEmail(userProfileDetail.email) === false) {
      toggle = activeToggle?.toggle ?? 'off';
    } else if (activeToggle?.toggle === 'whitelist') {
      toggle = config.whitelist.some((item) => item === userProfileDetail.email)
        ? 'on'
        : 'off';
    } else {
      toggle = 'off';
    }
  }

  return toggle;
}
